// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"649":"b1455bb5","721":"7571c195","741":"116e5111","743":"da98ab14"}[chunkId] + ".chunk.css";
};